export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export function unixToHumanTimestamp(unixTime: number, includeTime = false): string {
	const date = new Date(unixTime * 1000);

	const options: Intl.DateTimeFormatOptions = {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	};

	if (includeTime) {
		options.hour = 'numeric';
		options.minute = '2-digit';
		options.hour12 = true;
	}

	return date.toLocaleString('en-US', options);
}
